// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3HeKd","rootCenter":"LoadMoreObserver_rootCenter__3LWND","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3pLS7"};